import PropTypes from 'prop-types';
import React from 'react';

import VersatileSelect from './VersatileSelect';

function SingleSelect({ name, options, placeholder = 'Izberi ...', onChange, isClearable = false, ...rest }) {
    return (
        <VersatileSelect
            name={name}
            options={options}
            placeholder={placeholder}
            instanceId={name}
            onChange={onChange}
            isClearable={isClearable}
            isSearchable={false}
            {...rest}
        />
    );
}

SingleSelect.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired
};

export default SingleSelect;
